<template>
  <v-dialog v-model="dialogIsOpen" width="767px" max-height="559" min-height="400" persistent>
    <mf-loading loader-type="dialog" :boolean-loader="benefitLoading">
      <v-card>
        <v-card-title class="d-flex flex-column align-start">
          <h1 class="section-title">Comunicar</h1>
          <p class="subtitle" style="word-break: break-word">
            Por aqui você ainda pode iniciar uma nova campanha de comunicação a partir desse Cupom de Desconto. Dessa forma sua campanha já inicia com as mesmas
            informações, como nome, título, data de validade e público-alvo.
          </p>
          <h2 class="communicate-modal__campaign-title subtitle mt-2">O cupom de desconto</h2>
          <p class="communicate-modal__campaign-name">
            {{ benefit.title }} <span class="subtitle ml-2">{{ benefit.description }}</span>
          </p>
        </v-card-title>
        <v-card-text>
          <h3 class="communicate-modal__channels-title subtitle mb-0">Pelo canal</h3>
          <v-radio-group v-model="channelSelected" row class="mt-0">
            <v-row>
              <v-tooltip v-for="(channel, channelIndex) in channelsOptions" :key="channelIndex" top :disabled="channel.tooltipIsDisabled" max-width="200">
                <template v-slot:activator="{ on }">
                  <v-col :cols="channel.cols" v-on="on">
                    <v-radio color="primary" :value="channel.value" :disabled="channel.optionIsDisabled" :label="channel.label" />
                  </v-col>
                </template>
                <span v-if="channel.optionIsDisabled"
                  >Você não tem acesso a esse canal. Para mais informações, consulte seu consultor Mercafacil ou o nosso suporte</span
                >
              </v-tooltip>
            </v-row>
          </v-radio-group>
          <mf-action-buttons
            :primary-button="{
              text: 'Comunicar por esse canal',
              action: communicateBySelectedChannel,
              isVisible: true,
              isDisabled: disableCommunicateByChannelButton,
            }"
            :extra-button="{
              text: 'Fechar',
              action: closeModal,
              isVisible: true,
            }"
          />
        </v-card-text>
      </v-card>
    </mf-loading>
  </v-dialog>
</template>

<script>
import { getChannelsPermissionsStatus } from '@/modules/campanhas/gestao-ofertas-v2/helpers/channels'
import { abbreviation } from '@/config/helpers.js'
import { QUERY_FIND_BENEFIT_BY_ID } from '@/modules/campanhas/cupom-desconto/graphql'

export default {
  name: 'CommunicateModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    benefitId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    benefit: {},
    benefitLoading: false,
    channelSelected: '',
  }),
  computed: {
    dialogIsOpen: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    disableCommunicateByChannelButton() {
      const existBenefit = Object.entries(this.benefit)?.length

      return !existBenefit || !this.channelSelected
    },
    channelsPermissionsStatus() {
      return getChannelsPermissionsStatus(this.$permissions, this.$getAllowedModules)
    },
    channelsOptions() {
      const channels = [
        {
          cols: '6',
          value: 'SMS',
          label: 'SMS',
          optionIsDisabled: !this.channelsPermissionsStatus.sms,
          tooltipIsDisabled: this.channelsPermissionsStatus.sms,
        },
        {
          cols: '6',
          value: 'EMAIL',
          label: 'E-mail',
          optionIsDisabled: !this.channelsPermissionsStatus.email,
          tooltipIsDisabled: this.channelsPermissionsStatus.email,
        },
        {
          cols: '6',
          value: 'PUSH',
          label: 'Push aplicativo',
          optionIsDisabled: !this.channelsPermissionsStatus.push,
          tooltipIsDisabled: this.channelsPermissionsStatus.push,
        },
        {
          cols: '6',
          value: 'WHATSAPP',
          label: 'Whatsapp',
          optionIsDisabled: !this.channelsPermissionsStatus.whatsapp,
          tooltipIsDisabled: this.channelsPermissionsStatus.whatsapp,
        },
        {
          cols: '6',
          value: 'BANNER',
          label: 'Banner',
          optionIsDisabled: !this.channelsPermissionsStatus.banner,
          tooltipIsDisabled: this.channelsPermissionsStatus.banner,
        },
      ]

      return channels
    },
    firstChannelOptionSelectedByDefault() {
      const channelsAllowed = this.channelsOptions.filter((channel) => !channel.optionIsDisabled)

      return channelsAllowed[0].value
    },
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
  },
  watch: {
    async dialogIsOpen(value) {
      if (value) {
        this.getBenefit()
      }
    },
  },
  mounted() {
    this.channelSelected = this.firstChannelOptionSelectedByDefault
  },
  methods: {
    abbreviation,
    closeModal() {
      this.benefit = {}
      this.channelSelected = this.firstChannelOptionSelectedByDefault
      this.dialogIsOpen = false
    },
    async getBenefit() {
      try {
        this.benefitLoading = true
        const {
          data: { findBenefitById },
        } = await this.$apollo.query({
          query: QUERY_FIND_BENEFIT_BY_ID,
          variables: {
            id: this.benefitId,
            franchise: this.isFranchise,
          },
          context: {
            uri: this.$microservicesUrls['benefitsManager'],
          },
          fetchPolicy: 'no-cache',
        })
        this.benefit = findBenefitById
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao buscar dados do cupom', snackbarColor: 'error' })
      } finally {
        this.benefitLoading = false
      }
    },
    communicateBySelectedChannel() {
      const channelsRouteName = {
        SMS: 'campanhas-sms-cadastro',
        WHATSAPP: 'campanhas-whatsapp-cadastro',
        PUSH: 'campanhas-aplicativo-cadastro',
        EMAIL: 'campanhas-email-cadastro',
        BANNER: 'banners-new',
      }
      this.$router.push({ name: channelsRouteName[this.channelSelected], params: { benefitId: this.benefitId } })
    },
  },
}
</script>

<style lang="scss" scoped>
.communicate-modal__campaign-title {
  font-weight: bold;
  color: $cinza-d10;
}

.communicate-modal__campaign-name {
  font-size: 22px;
  color: $cinza-d10;
}

.communicate-modal__channels-title {
  font-weight: bold;
  color: $cinza-d10;
}

.communicate-modal__channel-name {
  position: absolute;
  top: -4px;
  color: $cinza-d10;
}

.communicate-modal__channel--disable {
  color: #00000042;
}
</style>
